/**
 * Типы для API запросов и ответов
 */

/**
 * Типы услуг для заявки на подключение
 */
export enum ConnectionRequestService {
  INTERNET = 'INTERNET',
  TV = 'TV',
  VIDEO_INTERCOM = 'VIDEO_INTERCOM',
  ROUTER = 'ROUTER',
  TV_BOX = 'TV_BOX',
  OTHER = 'OTHER',
}

/**
 * Payload для отправки заявки на подключение на backend
 */
export interface ConnectionRequestPayload {
  /** Имя клиента */
  name: string;
  /** Номер телефона */
  phone: string;
  /** Email (опционально) */
  email?: string;
  /** Адрес подключения */
  address: string;
  /** Полные данные адреса от DaData (опционально) */
  addressData?: DaDataSuggestion;
  /** Список выбранных услуг */
  services: ConnectionRequestService[];
  /** Описание для "Другое" (опционально) */
  otherDescription?: string;
}

/**
 * Данные формы заявки на подключение (устаревший интерфейс, оставлен для обратной совместимости)
 * @deprecated Используйте ConnectionRequestPayload
 */
export interface ConnectionRequestData {
  name: string;
  phone: string;
  email?: string;
  address: string;
  checkedInternet: boolean;
  checkedTV: boolean;
  checkedVideoDomoPhone: boolean;
  checkedOther: boolean;
  otherDescription?: string;
}

/**
 * Подсказка адреса от DaData API
 */
export interface DaDataSuggestion {
  /** Отформатированное значение адреса */
  value: string;
  /** Полное значение адреса без ограничений */
  unrestricted_value: string;
  /** Детальные данные адреса */
  data: {
    /** Почтовый индекс */
    postal_code?: string;
    /** Страна */
    country?: string;
    /** Регион */
    region?: string;
    /** Город */
    city?: string;
    /** Улица */
    street?: string;
    /** Дом */
    house?: string;
    /** Квартира */
    flat?: string;
    /** Широта */
    geo_lat?: string;
    /** Долгота */
    geo_lon?: string;
    /** Дополнительные поля от DaData */
    [key: string]: unknown;
  };
}

/**
 * Ответ от DaData API с предложениями адресов
 */
export interface DaDataSuggestResponse {
  /** Массив подсказок адресов */
  suggestions: DaDataSuggestion[];
}

/**
 * Типы для работы с оплатой
 */

/**
 * Интерфейс результата поиска счета
 */
export interface AccountSearchResult {
  /** Уникальный идентификатор счета */
  id: string;
  /** Номер лицевого счета */
  accountNumber: string;
  /** Отображаемое имя (ФИО владельца) */
  displayName?: string;
  /** Адрес подключения */
  address?: string;
  /** Текущий баланс счета */
  balance?: number;
  /** Флаг блокировки счета */
  isBlocked?: boolean;
  /** Дата, до которой оплачены услуги */
  paidUntil?: string | null;
}

/**
 * Интерфейс ответа при поиске счета
 */
export interface AccountSearchResponse {
  /** Массив найденных счетов */
  accounts: AccountSearchResult[];
}

/**
 * Интерфейс данных для генерации платежа
 */
export interface PaymentGenerateRequest {
  /** ID счета для оплаты */
  accountId: string;
  /** Сумма платежа */
  amount: number;
}

/**
 * Интерфейс ответа при генерации платежа
 */
export interface PaymentGenerateResponse {
  /** URL для перенаправления на страницу оплаты */
  paymentUrl: string;
  /** ID созданного счета на оплату */
  invoiceId: string;
}

/**
 * Интерфейс информации о лицевом счете авторизованного пользователя
 */
export interface SubscriberInfo {
  /** Уникальный идентификатор счета */
  id: string;
  /** Номер лицевого счета */
  accountNumber: string;
  /** Адрес подключения */
  address: string;
  /** Текущий баланс счета */
  balance: number;
  /** Флаг блокировки счета */
  isBlocked: boolean;
  /** Дата, до которой оплачены услуги */
  paidUntil?: string | null;
  /** Дата последнего списания */
  lastBillingDate?: string | null;
}
